/* 

refer to "Algorithms" document in Google Docs

at this moment, interests make up 60% of the equation, questions make up 40%.
eventually, this will change, based on more factors that we add to 
the match algorithm.

we are only exporting all functions because of testing.  
normally, the only function that should be exported is matchMeWith()

*/

export function matchMeWith(me, them, minMatchScore, today) {
  
  // if undefined...
  if (minMatchScore == undefined) minMatchScore = 50;

  if (today == undefined) {
    today = Date.now();
  } else if (today != undefined) {
    // translate date into timestamp
    try {
      today = convertDate(today);
    } catch (error) {
      console.log("convertDate error:", error);
    }
  }

  // run discarding tests
  // these test are either matched or not.  for example if someone is outside
  // a users gender preferences, the match will be discarded with a zero returned.
  // also, these tests don't contribute to the match score
  
  // gender test
  // console.log("gender test: ");
  if (gender(me, them) == false) return 0;
  // console.log("passed");
  
  // age preference test
  // console.log("agePreference test:");
  if (agePreference(me, them, today) == false) return 0;
  // console.log("passed");
  
  
  let match = 0;
  
  // tests below influence the final match result
  // multiply by 0.6 to take 100% and bring it down to "60%"
  // or 50 * 0.6 is 30%
  
  let interestsOut = interests(me, them);
  match = interestsOut * 0.55; // 55% of the overall match
  // console.log("interests test:", interestsOut);
  
  let questionsOut = questions(me, them);
  match += questionsOut * 0.35; // 35% of the overall match
  // console.log("questions test:", questionsOut);
  
  // do distance calculation - eventually 10% of the overall match
  let distanceOut = distance(me, them, me.distanceFriends);
  match += distanceOut * 0.1; // 10% of the overall match
  // console.log("distance test:", distanceOut);
  
  match = Math.round(match);
  // console.log("final match score:", match);
  
  // if (match < minMatchScore) return 0;
  
  return match;
}


/* 
convert birthday strings into timestamps
*/
export function convertDate(date) {
  // console.log("date:", date);
  if (date.length != 10) throw "birthday has incorrect length";
  
  let split = date.split("-");
  if (split.length != 3) throw "birthday has incorrect format";
  
  let out = new Date(split[0], split[1], split[2]).getTime();
  if (isNaN(out) == true) throw "birthday is not a number";
  
  return out;
}


/* 
two users must match both ways before this will return true, otherwise
this will return false.
*/
export function gender(me, them) {
  
  // match users from "me" to "them"
  if ( me.lookingFor.includes( them.gender ) == false ) {
    return false;
  }
  
  // match user from "them" to "me"
  if ( them.lookingFor.includes( me.gender ) == false ) {
    return false;
  }
  
  return true;
}


/* 
convert my birthday ("me") into a timestamp and subtract that from today to calc how old i am.

convert their birthday ("them") into a timestamp and subtract that from today to calc how old they are.

run age that through a verification to make sure the age is within an age range

today should already be in timestamp format
*/
export function agePreference(me, them, today) {
  
  let meTimestamp = null, themTimestamp = null;
  try {
    meTimestamp = convertDate(me.birthday);
    themTimestamp = convertDate(them.birthday);
  } catch (error) {
    console.log("error:", error);
    return false;
  }
  
  // calculate how old each user is
  // we don't need a perfect calculation here...
  const YEAR_IN_MS = 31536000000; // 365 * 24 * 60 * 60 * 1000
  let meAge = Math.floor( (today - meTimestamp) / YEAR_IN_MS );
  let themAge = Math.floor( (today - themTimestamp) / YEAR_IN_MS );
  
  // do "they" fit with "me"?
  if (themAge < me.agePreference[0] || themAge > me.agePreference[1]) {
    return false;
  }
  
  // do "me" fit with "they"?
  if (meAge < them.agePreference[0] || meAge > them.agePreference[1]) {
    return false;
  }
  
  return true;
}


/* 
interest matching

returns a percentage.  is reduced down to a maximum of 30% in "matchWithMe()"
*/

export function interests(me, them) {
  
  let matched = 0;
  for (let i in me.interests) {
    if (them.interests.includes( me.interests[i] ) == true ) {
      matched++;
    }
  }
  
  // console.log("matched interests:", matched, "total interests", me.interests.length);
  
  return Math.round( (matched / me.interests.length) * 100 );
}


/* 
question matching
*/

let distancePercentages = [100, 75, 50, 25, 0];
export function questions(me, them) {
  
  // we use "i" to loop through both arrays, because there will always be
  // the same length in both arrays and they both correspond to the same
  // questions asked
  let answered = 0;
  let total = 0;
  for (let i in me.questions) {
    
    // skip if "no answer"
    if (me.questions[i] == 0) continue;
    if (them.questions[i] == 0) continue;
    
    // calculate distance from "me answer" to "them answer"
    let distance = 0;
    
    // if we don't use ifs here, we might do a subtraction that ends up
    // with a negative number.  we don't want that...
    if (me.questions[i] > them.questions[i]) 
      distance = me.questions[i] - them.questions[i];
    
    if (me.questions[i] < them.questions[i]) 
      distance = them.questions[i] - me.questions[i];
    
    // console.log("distance:", distance);
    
    // add to the total, so we can get an average
    total += distancePercentages[distance];
    
    // incremented so we can get an average
    answered++;
  }
  
  if (total == 0 && answered == 0) return 0;
  return Math.round(total / answered);
  
}


/* 

just calculate the distance between two users

from https://www.movable-type.co.uk/scripts/latlong.html

*/

export function calcDistance(me, them, miles) {
  
  const R = 6371000; // metres
  const φ1 = me.lat * Math.PI / 180; // φ, λ in radians
  const φ2 = them.lat * Math.PI / 180;
  const Δφ = (them.lat - me.lat) * Math.PI / 180;
  const Δλ = (them.long - me.long) * Math.PI / 180;

  const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2( Math.sqrt(a), Math.sqrt(1 - a) );

  let d = R * c; // in meters
  
  if (miles == true) {
    // return in rounded miles
    d = Math.round(d * 0.0621371);
    d /= 100;
  } else {
    // return in rounded kilometers
    d = Math.round(d / 10);
    d /= 100;
  }
  
  return d;
}


/* 

calculate a match against the distance of two users

per Algorithm Google Doc:

(100 - ( ( 100 / user 1 miles selected ) * user 2 distance ) ) + (100 - ( ( 100 / user 2 miles selected ) * user 1 distance ) ) / 2= Match average

*/

export function distance(me, them, maxDistance) {
  
  let distance = calcDistance(me, them, true);
  let match = 100 - ( ( 100 / maxDistance ) * distance );
  
  if (match < 0) {
    return 0;
  }
  
  return Math.round(match);
  
}